module.exports = __webpack_public_path__ + "img/B_mask.a38e0f66.png";